import { useEffect } from "react";

const PaymentGatewayRedirection = ({ paymentData }) => {
    // Handles the payment gateway redirection
    useEffect(() => {
        if (!paymentData.waiting) {
            setTimeout(() => document.getElementById("paymentForm").submit(), 200);
        }
    }, [paymentData]);

    return (
        <div className="col-12 container-fluid" hidden>
            <form name="form" id="paymentForm" action={paymentData?.path} method="POST">
                <input
                    name="Ds_SignatureVersion"
                    value={paymentData?.params?.Ds_SignatureVersion}
                />
                <input
                    name="Ds_MerchantParameters"
                    value={paymentData?.params?.Ds_MerchantParameters}
                />
                <input name="Ds_Signature" value={paymentData?.params?.Ds_Signature} />
                <button className="btn btn-dark" value="Submit">
                    Enviar formulario
                </button>
            </form>
        </div>
    );
};

export default PaymentGatewayRedirection;
